import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import env from '../../../env';
import { HBox, VBox } from '../../../components/Box';
import { Car, Home } from '../../../components/Icon';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { formatLicensePlate } from '../../../utils/string';
import { selectWork } from '../../Api/selectors';
import { selectHomeCompany } from '../../Companies/selectors';
import { REQUEST_HOME_COMPANY } from '../../Companies/constants';
import { VehicleStatusLabel } from './VehicleStatusLabel';
import { VehicleAvatarSlider } from '../../../components/VehicleAvatarSlider';
import { CompanyLabelById } from '../../Companies/components/CompanyLabelById';
import { getVehicleStatusLabel } from '../helpers';
import styles from './VehicleHeader.module.css';
import cn from 'classnames';
import { AppClientId } from '../../Shared/constants';
import { WithWorkflow } from '../../Workflows/components/WithWorkflow';

dayjs.extend(customParseFormat);

const Container = styled.div`
  font-size: 12px;
  width: ${props => (props.wide ? '100%' : '')};
  .box1 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 8px;
  }
  .vin {
    text-transform: uppercase;
    white-space: nowrap;
  }
  .regplate {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px !important;
    white-space: nowrap;
  }

  .id {
    color: #aaa;
  }

  .avatar {
    margin-top: -25px;
    margin-right: -10px;
  }

  .status-block {
    margin-bottom: 20px;
  }
  .icon-house {
    color: rgb(21, 172, 121);
    font-size: 17px;
  }

  overflow: hidden;
`;

const STATE = {
  isHome: null,
  vehicleProps: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get plannableStatus() {
    return this.props.vehicle[this.props.task_name];
  }

  get isHomeLocation() {
    return this.props.homeCompany == this.props.vehicle?.location_company_id;
  }

  renderTransportDate() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.TransportDatum && this.props.hiltInspection) {
      return (
        <HBox className="gap-2">
          <span>
            
            {this.lbl('vehicle.info.inspection.transport_date')}:{' '}
           {' '}
            {this.props.vehicle.TransportDatum}
          
          </span>
        </HBox>
      );
    }

    return;
  }

  renderHILTafleverdatum() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.HILT_afleverdatum) {
      return (
        <><HBox className="gap-2">
          <strong className="text-decoration-underline">
            {this.lbl('vehicle.info.inspection.HILT_afleverdatum')}{' '}
            {this.props.vehicle.HILT_afleverdatum}
          </strong>
        </HBox><HBox className="gap-2">
            <strong className="text-decoration-underline">
              {this.lbl('vehicle.info.inspection.HILT_aflever_remarks')}{' '}
              {this.props.vehicle?.HILT_aflever_remarks}
            </strong>
          </HBox></>
      );
    }

    return;
  }

  HILTAdvertise() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.carcollect_award_amount) {
      return (
        <><HBox className="gap-2">
          <strong className="text-decoration-underline">
            {this.lbl('vehicle.property.carcollect_award_amount')}{' '}
            {this.props.vehicle.carcollect_award_amount}
          </strong>
        </HBox></>
      );
    }

    return;
  }
  

  renderHILTreserved() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.HILT_reserved) {
      return (
        <><HBox className="gap-2">
          <span>
        
            <VehicleStatusLabel status={1}>Gereserveerd</VehicleStatusLabel>
             {this.props.vehicle.HILT_reserved}
          </span>
        </HBox>
       {this.props.vehicle.HILT_reserved_date &&
        <HBox className="gap-2">
            <strong className="text-decoration-underline">
              {this.lbl('vehicle.info.inspection.HILT_reserved_date')}:{' '}
              {this.props.vehicle?.HILT_reserved_date}
            </strong>
          </HBox>
    }</>
      );
    }

    return;
  }

  renderHiltParkingspot() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.HILT_parkingspot) {
      return (
        <HBox className="gap-2">
          <span>{this.lbl('vehicle.property.HILT_parkingspot')}</span>
          <span>{this.props.vehicle.HILT_parkingspot}</span>
        </HBox>
      );
    }

    return;
  }
  renderStatusLabel() {
    const vehicle = this.props.vehicle;
    if (env.clientId === AppClientId.HILTERMANN) {
      return vehicle?.workflow_id ? (
        <VehicleStatusLabel>
          <WithWorkflow label abbreviation workflow_id={vehicle?.workflow_id} propertyName={'name'} />
        </VehicleStatusLabel>
      ) : (
        ''
      );
    }

    return (
      this.props.statusLabel || (
        <VehicleStatusLabel status={vehicle.status}>
          {getVehicleStatusLabel(vehicle.status, this.lbl, vehicle)}
        </VehicleStatusLabel>
      )
    );
  }

  renderExtraStatus() {
    const vehicle = this.props.vehicle;
    if (env.clientId === AppClientId.HOOIKAMMER && this.props.HOOI_NEW_belongings_in && vehicle?.HOOI_NEW_belongings_in) {
      const dateValue = vehicle?.HOOI_NEW_belongings_in;

      let status = 7;

      if (dateValue && dayjs().diff(dayjs(dateValue, 'DD-MM-YYYY'), 'day') > 28) {
        status = 1;
      }
      return (
        <VehicleStatusLabel status={status}>
          {this.lbl(`vehicle.property.HOOI_NEW_belongings_in.status.${status}`)}
        </VehicleStatusLabel>
      );
    }
    return;
  }

  renderBrandModel() {
    const vehicle = this.props.vehicle;
    return (
      <HBox>
        <div>
          <strong>
            {vehicle.brand_name}&nbsp;{vehicle.model_name}
          </strong>
        </div>
      </HBox>
    );
  }

  renderSegment() {
    if (env.clientId === AppClientId.HILTERMANN && this.props.vehicle.category_id) {
      return (
        <HBox className="gap-2" right>
          <span>{this.lbl('vehicle.property.category_id')}</span>
          <span>{this.props.vehicle.category_id}</span>
        </HBox>
      );
    }

    return;
  }

  render() {
    const vehicle = this.props.vehicle;

    if (!vehicle) return null;

    return (
      <Container className={styles.container} wide={this.props.wide} onClick={this.props.onClick}>
        <VBox>
          <HBox className={cn('status-block', styles.statusContainer)}>
            <VBox gap={'8px'}>
              {this.renderExtraStatus()}
              
              <HBox vCenter>
                {this.renderStatusLabel()}
             {this.renderSegment()}
              </HBox>
            </VBox>

            {this.isHomeLocation ? (
              <VBox className={styles.statusLabelContainer} right>
                {this.plannableStatus && (
                  <VehicleStatusLabel status={this.plannableStatus}>
                    {this.lbl('vehicle.plannable.status.' + this.plannableStatus)}
                  </VehicleStatusLabel>
                )}
                <div className="icon-house">
                  <Home />
                </div>
              </VBox>
            ) : (
              <div>
                {this.props.plannable && this.plannableStatus && (
                  <VehicleStatusLabel status={this.plannableStatus}>
                    {this.lbl('vehicle.plannable.status.' + this.plannableStatus)}
                  </VehicleStatusLabel>
                )}
              </div>
            )}
          </HBox>

          <HBox vCenter className="box1">
            <div className="mb-2">
              {this.props.brandTopPosition && this.renderBrandModel()}
              <br />
              <span className="regplate">{formatLicensePlate(vehicle.regplate)}</span>
              <br />
              <span className="vin">{vehicle.vin}</span>
              <br />
              <HBox left>
                <span className="id">{vehicle.id}</span>
                {env.clientId === AppClientId.HILTERMANN &&
                  (vehicle?.task_HILT_purchase_release_tdn_insurance == '0' ? (
                    <span style={{ color: 'red' }}>
                      <a
                        href={`https://ovi.rdw.nl/?kenteken=${vehicle?.regplate}`}
                        target="_blank"
                        onClick={e => e.stopPropagation()}
                        style={{ color: 'inherit' }}
                        title="In bedrijfsvoorraad"
                      >
                        <Car style={{ color: 'red' }} />
                      </a>
                    </span>
                  ) : (
                    <span style={{ color: 'green' }}>
                      <a
                        href={`https://ovi.rdw.nl/?kenteken=${vehicle?.regplate}`}
                        target="_blank"
                        onClick={e => e.stopPropagation()}
                        style={{ color: 'inherit' }}
                        title="Niet in bedrijfsvoorraad"
                      >
                        <Car style={{ color: 'green' }} />
                      </a>
                    </span>
                  ))}
              </HBox>
              <br />

              {/* <CompanyLabelById company_id={vehicle?.creditor_company} /> */}
              
              {this.props.stockShortlease && this.renderHILTreserved()}
              
              {this.props.HILTAdvertise && this.HILTAdvertise()}
              {this.renderHILTafleverdatum()}
            </div>

            {/* {env.disable_SIRV ? (
              <VehicleAvatarSlider className={styles.avatarVehicle} withoutSlide vehicle={vehicle} onClick={this.tofn(`/vehicles/${vehicle.id}`)} />
            ) : (
              <VehicleAvatar className={styles.avatarVehicle} vehicle={vehicle} onClick={this.tofn(`/vehicles/${vehicle.id}`)} />
            )} */}
            <VehicleAvatar
              className={styles.avatarVehicle}
              autoLoadPhotos={this.props.loadSingleRes}
              vehicle={vehicle}
              onClick={this.tofn(`/vehicles/${vehicle.id}`)}
              kanbanCell={this.props.kanbanCell}
            />
          </HBox>

          {this.renderTransportDate()}
          {this.renderHiltParkingspot()}
        </VBox>

        {!this.props.brandTopPosition && this.renderBrandModel()}
        {/* <HBox>
          <Button
            disabled={!vehicle?.incoming_invoice}
            small
            onClick={() => this.to(`/invoices/${vehicle?.incoming_invoice}`)}
          >
            {this.lbl('vehicle.details.incomingInvoiceLbl')}
          </Button>
        </HBox> */}
      </Container>
    );
  }
}

VehicleHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_HOME_COMPANY),
    homeCompany: selectHomeCompany(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHeader = compose(withConnect, withRouter)(VehicleHeaderComp);
